import React, { useState, useEffect } from 'react';
import { HexColorPicker } from 'react-colorful';
import { colord, extend } from 'colord';
import namesPlugin from 'colord/plugins/names';

import { InputContainer, Input } from '../../styles';
import { BackgroundPreview, Block } from './styles';

extend([namesPlugin]);

export default React.memo(({ color, onChange }) => {
  const [displayColor, setDisplayColor] = useState('#000000');

  useEffect(() => setDisplayColor(color.startsWith('#') ? color : colord(color).toHex()), [color]);

  return (
    <InputContainer>
      <Block>
        <HexColorPicker color={displayColor} onChange={onChange} />
      </Block>
      <Block>
        <Input value={color} onChange={(e) => onChange(e.target.value)} />
        <BackgroundPreview backgroundColor={color}></BackgroundPreview>
      </Block>
    </InputContainer>
  );
});
